export default {"src":"/_next/static/media/ChatBot.d7320735.svg","height":45,"width":42,"blurWidth":0,"blurHeight":0};